import styled from 'styled-components'


export const ShowCaseDiv = styled.div `
display:flex;
	/* flex-direction:row; */
	justify-content:center;
    color: #fff;
	min-height: 100vh;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
	padding:0;
	margin:0;

	

.banner{
	width:100%;
}
.yourhealthbox{
	display:flex;
	flex-direction:column;
	padding-top:120px;
	text-align:start;
	/* margin-left:100px; */
	
	button{
		border-radius: 10px;
		font-family: Gilroy;
            font-style: normal;
            font-weight: 600;
            font-size: 17px;
            line-height: 30px;
            text-align: center;
            font-feature-settings: 'liga' off;

			width: 150px;
            height: 45px;
            background: #1DCDFE;
            border-style:hidden;
            :focus{
                box-shadow: none;
            }
            color: #fff;
		
		

	}
}

h2{
	font-family: Gilroy;
	font-style: normal;
	font-weight: bold;
	font-size: 72px;
	line-height: 98px;
	font-feature-settings: 'liga' off;
}
.your{
	color:#02021C;

}
.health{
	color:#1E90FF;
	
}
.our{
	color:#02021C;
}
.priority{
	color:#1DCDFE
}


/* mobile view */
@media (max-width:500px){	
.banner{
	button{

		display:flex;
		align-items:center;
		justify-content:center;
		justify-self:center;
		}
	}

}


@media (max-width:400px){
	.yourhealthbox{
		h2{
			font-family: Gilroy;
			font-style: normal;
			font-weight: bold;
			font-size: 52px;
			line-height: 98px;
			font-feature-settings: 'liga' off;
		}
		
	}
}




`